document.addEventListener("DOMContentLoaded", () => {
    const mobileNav = document.getElementById("mobile-nav");

    if (!mobileNav) {
        return;
    }

    const scrollContainer = mobileNav.querySelector(
        ":scope > .off-canvas-content"
    );

    const rootNav = mobileNav.querySelector("nav > .nav-tree");

    const panels = [
        ...mobileNav.querySelectorAll(".mobile-mega-menu-panel")
    ];

    const nextButtons = [
        ...mobileNav.querySelectorAll(".mobile-menu-next")
    ];

    const backButtons = [
        ...mobileNav.querySelectorAll(".mobile-menu-back")
    ];

    const resetMenuScroll = () => {
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
    };

    const hideRoot = () => {
        if (rootNav) {
            rootNav.hidden = true;
        }
    };

    const showRoot = () => {
        if (rootNav) {
            rootNav.hidden = false;
        }
    };

    const hideAllPanels = () => {
        panels.forEach(panel => {
            panel.setAttribute("aria-hidden", "true");
        });

        nextButtons.forEach(button => {
            button.setAttribute("aria-expanded", "false");
        });
    };

    const getPanel = (button) => {
        const panelId = button.getAttribute("aria-controls");

        if (!panelId) {
            return null;
        }

        return document.getElementById(panelId);
    };

    const getParentPanel = (panel) => {
        if (!panel) {
            return null;
        }

        const opener = mobileNav.querySelector(
            `.mobile-menu-next[aria-controls="${panel.id}"]`
        );

        if (!opener) {
            return null;
        }

        return opener.closest(".mobile-mega-menu-panel");
    };

    nextButtons.forEach(button => {
        button.addEventListener("click", () => {
            const panel = getPanel(button);

            if (!panel) {
                return;
            }

            const currentPanel =
                button.closest(".mobile-mega-menu-panel");

            if (currentPanel) {
                currentPanel.setAttribute(
                    "aria-hidden",
                    "true"
                );
            } else {
                hideRoot();
            }

            button.setAttribute(
                "aria-expanded",
                "true"
            );

            panel.setAttribute(
                "aria-hidden",
                "false"
            );

            panel.focus({ preventScroll: true });
            resetMenuScroll();
        });
    });

    backButtons.forEach(button => {
        button.addEventListener("click", () => {
            const currentPanel =
                button.closest(".mobile-mega-menu-panel");

            if (!currentPanel) {
                return;
            }

            const parentPanel =
                getParentPanel(currentPanel);

            currentPanel.setAttribute(
                "aria-hidden",
                "true"
            );

            const opener = mobileNav.querySelector(
                `.mobile-menu-next[aria-controls="${currentPanel.id}"]`
            );

            opener?.setAttribute(
                "aria-expanded",
                "false"
            );

            if (parentPanel) {
                parentPanel.setAttribute(
                    "aria-hidden",
                    "false"
                );

                parentPanel.focus({ preventScroll: true });
            } else {
                showRoot();

                opener?.focus({ preventScroll: true });
            }

            resetMenuScroll();
        });
    });

    $("#mobile-nav").on("offcanvasMenu.hidden", () => {
        hideAllPanels();
        showRoot();
        resetMenuScroll();
    });

    hideAllPanels();
    showRoot();
    resetMenuScroll();
});